import React, { useEffect, useRef, useState } from 'react';

function Logo({ className }) {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    observer.observe(element);

    return () => observer.disconnect(); // Cleanup on unmount
  }, []);

  // Determine which image to use based on available space
  const isCompact = containerWidth < 770;
  const imageSrc = isCompact
    ? '/images/2025.05/Logo_definitief-transparant-cropped-h150.png'
    : '/images/2025.05/Logo_definitief-transparant-cropped-h150.png';
  const imageMaxWidth = isCompact ? 275 : 600;

  return (
    <div ref={containerRef} className={className}>
      <a className='logo-img' href='/'>
        <img
          src={imageSrc}
          alt="Artsenpraktijk Waarloos"
          style={{
            maxWidth: Math.min(containerWidth, imageMaxWidth),
            height: 'auto',
            transition: 'max-width 0.3s ease',
          }}
        />
      </a>
    </div>
  );
}

export default Logo
